import * as types from '../mutationTypes'
const state = {
  tabActive: '' // 激活的说明页
}

const mutations = {
  [types.STE_TAB_ACTIVE] (state, data) {
    state.tabActive = data
  }
}

const actions = {
  setTabActive ({ commit }, data) {
    commit(types.STE_TAB_ACTIVE, data)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
